import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-information-circle-bold',
    templateUrl: './icon-information-circle-bold.component.html',
    styleUrls: ['./icon-information-circle-bold.component.css'],
    standalone: true,
})
export class IconInformationCircleBoldComponent {
  @Input() color = '#b78f41';
  @Input() width = '24';
  @Input() height = '24';
}
